import React from 'react'
import { Form, InputNumber } from 'antd'
import Access from '../../../../../../components/access/Access'
import { AssignmentPermissions } from '../../../../../../../../constants/assignment-permissions'
import Text from 'antd/es/typography/Text'

const TestMemoryLimit = ({ initialValue }) => {
    return (
        <Form.Item
            label='Memory limit, KB'
            name='memoryLimit'
            rules={[
                {
                    type: 'number',
                    min: 2048,
                    max: 5120000,
                },
            ]}
            initialValue={128000}
        >
            <Access
                permissions={[AssignmentPermissions.CAN_EDIT]}
                fallback={<Text>{initialValue}</Text>}
            >
                <InputNumber step={1024} />
            </Access>
        </Form.Item>
    )
}

export default TestMemoryLimit
